import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import NutUI from "@nutui/nutui";
// 采用按需加载时  此全局css样式，需要删除
import "@nutui/nutui/dist/style.css";
import { Toast } from "@nutui/nutui";
createApp(App).use(NutUI).use(Toast).use(router).mount("#app");
